import { configureStore } from '@reduxjs/toolkit'
import { counterSlicer } from './counter'
import { newSalesBillingSlicer } from './newSalesBilling'

export const store = configureStore({
  reducer: {
    counter: counterSlicer.reducer,
    newSalesBilling: newSalesBillingSlicer.reducer
  }
})